import { sspConfig, sspProjectConfig } from "@/setup/openApiConfig";
import {
  ProjectsApi,
  ProjectApi,
  SynthesisApi,
  SynthesisAttachmentApi,
  ProjectInformationApi,
  OutdoorSpaceApi,
  ComplaintApi,
  PollutedEnvironmentApi,
  PollutedExtraEnvironmentApi,
  AttachmentApi,
  AdditionalPlanApi,
  FusionICPEApi,
  FusionAccidentApi,
  FusionActivityApi,
  FusionPollutionApi,
  FusionProductApi,
  FusionRestrictionApi,
  FusionBuildingApi,
  FusionComponentApi,
  FusionZoneApi,
  FusionOtherItemApi,
  FusionOutdoorSpaceApi,
  FusionBasiasBasolSISNearbySiteApi,
  FusionBombingsApi,
  HistoricalAccidentApi,
  HistoricalActivityApi,
  HistoricalPollutionApi,
  HistoricalProductApi,
  HistoricalRestrictionApi,
  HistoricalICPEApi,
  HistoricalBombingsApi,
  HistoricalResearchApi,
  ConsultedDocumentsApi,
  ReferencedDocumentsApi,
  SiteApi,
  SiteSynthesisApi,
  TestimonyApi,
  CadasterApi,
  SectionApi,
  CaseApi,
  ClientApi,
  DashboardApi,
  ElementaryMissionApi,
  GlobalMissionApi,
  ImmediateDangerApi,
  IncertitudeApi,
  MissionArchiveApi,
  NeighborUseApi,
  NeighbourUseElementApi,
  NeighbourUseElementPictureApi,
} from "@socotec.io/ssp-back-sdk";

export const projectsApi = new ProjectsApi(sspProjectConfig);

export const outdoorSpaceApi = new OutdoorSpaceApi(sspProjectConfig);

// Environments
export const complaintApi = new ComplaintApi(sspProjectConfig);
export const pollutedEnvironmentApi = new PollutedEnvironmentApi(sspProjectConfig);
export const pollutedExtraEnvironmentApi = new PollutedExtraEnvironmentApi(sspProjectConfig);

// Project information documents
export const attachmentApi = new AttachmentApi(sspProjectConfig);
export const additionalPlanApi = new AdditionalPlanApi(sspProjectConfig);

// Fusion resources
export const fusionICPEApi = new FusionICPEApi(sspProjectConfig);
export const fusionAccidentApi = new FusionAccidentApi(sspProjectConfig);
export const fusionActivityApi = new FusionActivityApi(sspProjectConfig);
export const fusionPollutionApi = new FusionPollutionApi(sspProjectConfig);
export const fusionProductApi = new FusionProductApi(sspProjectConfig);
export const fusionRestrictionApi = new FusionRestrictionApi(sspProjectConfig);
export const fusionBuildingApi = new FusionBuildingApi(sspProjectConfig);
export const fusionComponentApi = new FusionComponentApi(sspProjectConfig);
export const fusionZoneApi = new FusionZoneApi(sspProjectConfig);
export const fusionOtherItemApi = new FusionOtherItemApi(sspProjectConfig);
export const fusionOutdoorSpaceApi = new FusionOutdoorSpaceApi(sspProjectConfig);
export const fusionBasiasBasolSISNearbySiteApi = new FusionBasiasBasolSISNearbySiteApi(
  sspProjectConfig,
);
export const fusionBombingsApi = new FusionBombingsApi(sspProjectConfig);

// Historical resources
export const historicalAccidentApi = new HistoricalAccidentApi(sspProjectConfig);
export const historicalActivityApi = new HistoricalActivityApi(sspProjectConfig);
export const historicalPollutionApi = new HistoricalPollutionApi(sspProjectConfig);
export const historicalProductApi = new HistoricalProductApi(sspProjectConfig);
export const historicalRestrictionApi = new HistoricalRestrictionApi(sspProjectConfig);
export const historicalICPEApi = new HistoricalICPEApi(sspProjectConfig);
export const historicalBombingsApi = new HistoricalBombingsApi(sspProjectConfig);
export const historicalResearchApi = new HistoricalResearchApi(sspProjectConfig);

// Historical research consulted documents
export const consultedDocumentsApi = new ConsultedDocumentsApi(sspProjectConfig);

// Site information
export const cadasterApi = new CadasterApi(sspProjectConfig);

// Case and client (Atlas-owned data, edited from the mission screens)
export const caseApi = new CaseApi(sspProjectConfig);
export const clientApi = new ClientApi(sspProjectConfig);

// Mission planning
export const dashboardApi = new DashboardApi(sspProjectConfig);
export const missionArchiveApi = new MissionArchiveApi(sspProjectConfig);

// Mission reference tables: read-only and not project-scoped, so they use the
// plain configuration (no project_id query param to add).
export const elementaryMissionApi = new ElementaryMissionApi(sspConfig);
export const globalMissionApi = new GlobalMissionApi(sspConfig);

// Site risks and project incertitudes
export const immediateDangerApi = new ImmediateDangerApi(sspProjectConfig);
export const incertitudeApi = new IncertitudeApi(sspProjectConfig);

// Neighboring uses
export const neighborUseApi = new NeighborUseApi(sspProjectConfig);
export const neighbourUseElementApi = new NeighbourUseElementApi(sspProjectConfig);
export const neighbourUseElementPictureApi = new NeighbourUseElementPictureApi(sspProjectConfig);

export const projectApi = new ProjectApi(sspProjectConfig);
export const synthesisApi = new SynthesisApi(sspProjectConfig);
export const synthesisAttachmentApi = new SynthesisAttachmentApi(sspProjectConfig);
export const projectInformationApi = new ProjectInformationApi(sspProjectConfig);
export const sectionApi = new SectionApi(sspProjectConfig);
export const siteApi = new SiteApi(sspProjectConfig);
export const siteSynthesisApi = new SiteSynthesisApi(sspConfig);
export const testimonyApi = new TestimonyApi(sspProjectConfig);
export const referencedDocumentsApi = new ReferencedDocumentsApi(sspProjectConfig);
